export const makeTokenRequest = function (ajaxService, tokenRequestParameters) {
    return ajaxService
        .send(tokenRequestParameters.url, tokenRequestParameters.options)
        .then(response => {
        if (response.status < 200 || response.status > 299) {
            throw new Error(response.statusText);
        }
        return response.text();
    })
        .then(response => tokenRequestParameters.parser(response))
        .catch(err => { throw new Error(err); });
};
//# sourceMappingURL=makeTokenRequest.js.map